// // components/DriverManager.js
// import React, { useState, useEffect, useContext } from 'react';
// import {
//   View,
//   Text,
//   TextInput,
//   TouchableOpacity,
//   ScrollView,
//   StyleSheet,
//   Alert,
// } from 'react-native';
// import { useTranslation } from '../i18n';
// import { AppContext } from "../../App";

// const COLORS = {
//   primary: '#14B8A6',
//   background: '#F7F9FA',
//   card: '#FFFFFF',
//   textDark: '#1C1C1E',
//   textMuted: '#6B7280',
//   error: '#DC2626',
//   border: '#E5E7EB',
// };

// const API_BASE_URL = "https://api.taxi-yaounde.com";
// // const API_BASE_URL = "http://localhost:4000";

// const DriverManager = ({
//   vehicleId,
//   verificationId,
//   onDriversChange,
//   initialDrivers = [],
// }) => {
//   const scrollViewRef = React.useRef(null);

//   const { t } = useTranslation();
//   // const [drivers, setDrivers] = useState([]);
//   const [drivers, setDrivers] = useState(() =>
//     Array.isArray(initialDrivers) ? initialDrivers : []
//   );
//   const [loading, setLoading] = useState(false);
//   const { setFormProgress, verification, setVerification } = useContext(AppContext);
  
//   // Fetch existing drivers for this vehicle
//   useEffect(() => {
//     if (vehicleId) {
//       fetchExistingDrivers();
//     }
//   }, [vehicleId]);

//   // ✅ Update verification context whenever drivers change
//   useEffect(() => {
//     updateOwnerAddedDriverPersonIds();
//   }, [drivers]);


//   const updateOwnerAddedDriverPersonIds = () => {
//   // ✅ Only include drivers that were ADDED in THIS workflow (not fetched from DB)
//   const ownerAddedDriverPersonIds = drivers
//     .filter(d => !d.fetchedFromDB && d.personId)  // Newly created drivers with personId
//     .map(d => d.personId);
  
//   console.log("Newly added driver personIds: - DriverManager.js:63", ownerAddedDriverPersonIds);
  
//   setVerification(prev => ({ 
//     ...prev, 
//     ownerAddedDriverPersonIds 
//   }));
// };

//   const fetchExistingDrivers = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(
//         `${API_BASE_URL}/api/verification/vehicles/${vehicleId}/drivers`
//       );
//       const data = await response.json();
      
//       if (data.success && data.drivers) {
//         const existingDrivers = data.drivers.map(driver => ({
//           ...driver,
//           isExisting: true,
//           fetchedFromDB: true,
//         }));
//         setDrivers(existingDrivers);
//         onDriversChange(existingDrivers);
        
//         // ✅ Update context after fetching existing drivers
//         updateOwnerAddedDriverPersonIds();
//       } else {
//         setDrivers([]);
//         onDriversChange([]);
//         updateOwnerAddedDriverPersonIds();
//       }
//     } catch (error) {
//       console.error('Error fetching drivers: - DriverManager.js:96', error);
//       setDrivers([]);
//       onDriversChange([]);
//       updateOwnerAddedDriverPersonIds();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addDriver = () => {
//     const newDriver = {
//       id: Date.now().toString(),
//       name: '',
//       phone: '',
//       email: '',
//       birthDate: '',
//       gender: '',
//       cinNumber: '',
//       taxpayerNumber: '',
//       licenseNumber: '',
//       driverSyndicate: '', 
//       isExisting: false,
//       fetchedFromDB: false,
//     };
//     const updatedDrivers = [newDriver, ...drivers];
//       setDrivers(updatedDrivers);
//       onDriversChange(updatedDrivers);
      
//       // Optional: Scroll to top after adding
//         // Auto-scroll to top
//       setTimeout(() => {
//         scrollViewRef.current?.scrollTo({ y: 0, animated: true });
//       }, 100);
//     };

//   const removeDriver = (index) => {
//     if (drivers[index].fetchedFromDB) {
//       Alert.alert(
//         t('driverManager.cannotRemove'),
//         t('driverManager.cannotRemoveMessage')
//       );
//       return;
//     }
//     const newDrivers = [...drivers];
//     newDrivers.splice(index, 1);
//     setDrivers(newDrivers);
//     onDriversChange(newDrivers);
//   };

//   const updateDriver = (index, field, value) => {
//     const newDrivers = [...drivers];
//     newDrivers[index][field] = value;
    
//     if (newDrivers[index].fetchedFromDB && field !== 'searchTerm') {
//       newDrivers[index].isModified = true;
//     }
    
//     setDrivers(newDrivers);
//     onDriversChange(newDrivers);
//   };

//   const searchExistingDriver = async (cinOrLicense, index) => {
//     if (!cinOrLicense.trim()) return;
    
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/api/verification/persons/search?cin=${cinOrLicense}&license=${cinOrLicense}`
//       );
//       const data = await response.json();
      
//       if (data.success && data.person) {
//         const newDrivers = [...drivers];
//         newDrivers[index] = {
//           ...newDrivers[index],
//           ...data.person,
//           isExisting: true,
//           fetchedFromDB: true,
//           personId: data.person.personId,
//         };
//         setDrivers(newDrivers);
//         onDriversChange(newDrivers);
        
//         // ✅ Update context after finding existing driver
//         updateOwnerAddedDriverPersonIds();
        
//         Alert.alert(
//           t('driverManager.driverFound'),
//           t('driverManager.driverFoundMessage')
//         );
//       }
//     } catch (error) {
//       console.error('Error searching driver: - DriverManager.js:187', error);
//     }
//   };

//   // ✅ Function to handle saving a new driver (when they get a personId)
//   const handleSaveDriverToBackend = async (index) => {
//     const driver = drivers[index];
    
//     // Skip if already fetched from DB or doesn't have required info
//     if (driver.fetchedFromDB || !driver.name || !driver.phone) {
//       return;
//     }
    
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/api/verification/persons/create`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             name: driver.name,
//             phone: driver.phone,
//             email: driver.email || '',
//             birthDate: driver.birthDate || '',
//             gender: driver.gender || '',
//             cinNumber: driver.cinNumber || '',
//             taxpayerNumber: driver.taxpayerNumber || '',
//             licenseNumber: driver.licenseNumber || '',
//             driverSyndicate: driver.driverSyndicate || '',
//           }),
//         }
//       );
      
//       const data = await response.json();
      
//       if (data.success && data.personId) {
//         // Update the driver with the new personId
//         const newDrivers = [...drivers];
//         newDrivers[index].personId = data.personId;
//         setDrivers(newDrivers);
//         onDriversChange(newDrivers);
        
//         // ✅ Update context with the new personId
//         updateOwnerAddedDriverPersonIds();
        
//         Alert.alert(
//           t('driverManager.driverSaved'),
//           t('driverManager.driverSavedMessage')
//         );
//       }
//     } catch (error) {
//       console.error('Error saving driver: - DriverManager.js:240', error);
//       Alert.alert(
//         t('common.error'),
//         t('driverManager.saveError')
//       );
//     }
//   };

//   return (
//     <View style={styles.container}>
//       <View style={styles.header}>
//         <Text style={styles.title}>{t('driverManager.title')}</Text>
//         <TouchableOpacity style={styles.addButton} onPress={addDriver}>
//           <Text style={styles.addButtonText}>{t('driverManager.addDriver')}</Text>
//         </TouchableOpacity>
//       </View>

//       {loading ? (
//         <Text style={styles.loadingText}>{t('driverManager.loadingDrivers')}</Text>
//       ) : (
//         <ScrollView style={styles.scrollView} ref={scrollViewRef}>
//           {drivers.map((driver, index) => (
//             <View key={driver.id || driver.personId || index} style={styles.driverCard}>
//               <View style={styles.cardHeader}>
//                 <Text style={styles.driverTitle}>
//                   {t('driverManager.driverTitle').replace("{{number}}", index + 1)}
//                   {driver.fetchedFromDB && t('driverManager.existingInDatabase')}
//                   {driver.isModified && t('driverManager.modified')}
//                 </Text>
//                 {!driver.fetchedFromDB && (
//                   <TouchableOpacity onPress={() => removeDriver(index)}>
//                     <Text style={styles.removeText}>{t('common.remove')}</Text>
//                   </TouchableOpacity>
//                 )}
//               </View>

//               {/* Driver fields */}
//               <Text style={styles.label}>{t('driverManager.fields.fullName')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.name}
//                 onChangeText={(text) => updateDriver(index, 'name', text)}
//                 placeholder={t('driverManager.fields.fullName')}
//                 editable={true}
//               />

//               <Text style={styles.label}>{t('driverManager.fields.phone')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.phone}
//                 onChangeText={(text) => updateDriver(index, 'phone', text)}
//                 placeholder={t('driverManager.fields.phone')}
//                 keyboardType="phone-pad"
//                 editable={true}
//               />

//               <Text style={styles.label}>{t('driverManager.fields.email')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.email}
//                 onChangeText={(text) => updateDriver(index, 'email', text)}
//                 placeholder={t('driverManager.fields.email')}
//                 keyboardType="email-address"
//                 autoCapitalize="none"
//                 editable={true}
//               />

//               <Text style={styles.label}>{t('driverManager.fields.birthDate')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.birthDate}
//                 onChangeText={(text) => updateDriver(index, 'birthDate', text)}
//                 placeholder="DD/MM/YYYY"
//                 editable={true}
//               />

//               <Text style={styles.label}>{t('driverManager.fields.gender')}</Text>
//               <View style={styles.row}>
//                 {[t('driverManager.genders.male'), t('driverManager.genders.female')].map((gender) => (
//                   <TouchableOpacity
//                     key={gender}
//                     style={[
//                       styles.genderButton,
//                       driver.gender === gender && styles.genderButtonActive,
//                     ]}
//                     onPress={() => updateDriver(index, 'gender', gender)}
//                   >
//                     <Text
//                       style={[
//                         styles.genderText,
//                         driver.gender === gender && styles.genderTextActive,
//                       ]}
//                     >
//                       {gender}
//                     </Text>
//                   </TouchableOpacity>
//                 ))}
//               </View>

//               <Text style={styles.label}>{t('driverManager.fields.cinNumber')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.cinNumber}
//                 onChangeText={(text) => updateDriver(index, 'cinNumber', text)}
//                 placeholder={t('driverManager.fields.cinNumber')}
//                 editable={true}
//               />

//               <Text style={styles.label}>{t('driverManager.fields.taxpayerNumber')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.taxpayerNumber}
//                 onChangeText={(text) => updateDriver(index, 'taxpayerNumber', text)}
//                 placeholder={t('driverManager.fields.taxpayerNumber')}
//                 editable={true}
//               />

//               <Text style={styles.label}>{t('driverManager.fields.licenseNumber')}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.licenseNumber}
//                 onChangeText={(text) => updateDriver(index, 'licenseNumber', text)}
//                 placeholder={t('driverManager.fields.licenseNumber')}
//                 editable={true}
//               />
//               <Text style={styles.label}>{t("driverManager.fields.driverSyndicate")}</Text>
//               <TextInput
//                 style={styles.input}
//                 value={driver.driverSyndicate}
//                 onChangeText={(text) => updateDriver(index, 'driverSyndicate', text)}
//                 placeholder={t("driverManager.fields.driverSyndicate")}
//                 editable={true}
//               />
//             </View>
//           ))}
//         </ScrollView>
//       )}
//     </View>
//   );
// };

// const styles = StyleSheet.create({
//   container: {
//     backgroundColor: COLORS.card,
//     borderRadius: 16,
//     padding: 16,
//     marginVertical: 8,
//   },
//   header: {
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: 16,
//   },
//   title: {
//     fontSize: 18,
//     fontWeight: '700',
//     color: COLORS.textDark,
//   },
//   addButton: {
//     backgroundColor: COLORS.primary,
//     paddingHorizontal: 16,
//     paddingVertical: 8,
//     borderRadius: 8,
//   },
//   addButtonText: {
//     color: '#FFFFFF',
//     fontWeight: '600',
//   },
//   scrollView: {
//     maxHeight: 400,
//   },
//   driverCard: {
//     backgroundColor: COLORS.background,
//     borderRadius: 12,
//     padding: 16,
//     marginBottom: 12,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     borderLeftWidth: 4,
//     borderLeftColor: COLORS.primary,
//   },
//   cardHeader: {
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: 12,
//   },
//   driverTitle: {
//     fontSize: 16,
//     fontWeight: '600',
//     color: COLORS.textDark,
//   },
//   removeText: {
//     color: COLORS.error,
//     fontWeight: '600',
//   },
//   searchSection: {
//     marginBottom: 12,
//   },
//   searchInput: {
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     borderRadius: 8,
//     padding: 10,
//     fontSize: 14,
//   },
//   label: {
//     fontSize: 14,
//     fontWeight: '600',
//     color: COLORS.textMuted,
//     marginTop: 8,
//     marginBottom: 4,
//   },
//   input: {
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     borderRadius: 8,
//     padding: 10,
//     fontSize: 14,
//     marginBottom: 8,
//   },
//   row: {
//     flexDirection: 'row',
//     gap: 10,
//     marginBottom: 8,
//   },
//   genderButton: {
//     paddingHorizontal: 16,
//     paddingVertical: 8,
//     borderRadius: 8,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//   },
//   genderButtonActive: {
//     backgroundColor: COLORS.primary,
//     borderColor: COLORS.primary,
//   },
//   genderText: {
//     color: COLORS.textDark,
//     fontWeight: '600',
//   },
//   genderTextActive: {
//     color: '#FFFFFF',
//   },
//   loadingText: {
//     textAlign: 'center',
//     color: COLORS.textMuted,
//     padding: 20,
//   },
// });

// export default DriverManager;

// components/DriverManager.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  Alert,
} from 'react-native';
import { useTranslation } from '../i18n';
import { AppContext } from "../../App";
import LicenseCategoryDropdown from './LicenseCategoryDropdown';
import DriverDocumentUpload from './DriverDocumentUpload';
import { uploadDriverDocument } from '../api/driverDocumentApi';

const COLORS = {
  primary: '#14B8A6',
  background: '#F7F9FA',
  card: '#FFFFFF',
  textDark: '#1C1C1E',
  textMuted: '#6B7280',
  error: '#DC2626',
  border: '#E5E7EB',
};

const EMPTY_DRIVER_DOCUMENT = {
  front: null,
  back: null,
  pdf: null,
  skipped: false,
};

function emptyDriverDocument() {
  return { ...EMPTY_DRIVER_DOCUMENT };
}

function skippedDriverDocument() {
  return {
    front: null,
    back: null,
    pdf: null,
    skipped: true,
  };
}

function normalizeDriverDocumentValue(value) {
  if (!value) return emptyDriverDocument();

  if (
    Object.prototype.hasOwnProperty.call(value, 'front') ||
    Object.prototype.hasOwnProperty.call(value, 'back') ||
    Object.prototype.hasOwnProperty.call(value, 'pdf') ||
    Object.prototype.hasOwnProperty.call(value, 'skipped')
  ) {
    return {
      front: value.front || null,
      back: value.back || null,
      pdf: value.pdf || null,
      skipped: Boolean(value.skipped),
    };
  }

  // Backward compatibility with the old single-file state.
  if (value.uri || value.name || value.mimeType || value.type) {
    return {
      front: value,
      back: null,
      pdf: null,
      skipped: false,
    };
  }

  return emptyDriverDocument();
}

function hasCompleteTwoSidedDocument(value, options = {}) {
  const { photoOnly = false } = options;
  const v = normalizeDriverDocumentValue(value);

  if (v.skipped) return true;

  if (photoOnly) {
    return Boolean(v.front);
  }

  if (v.pdf) return true;

  return Boolean(v.front && v.back);
}

function pushDriverDocumentUploads(uploadPromises, {
  verificationId,
  personId,
  docType,
  value,
  photoOnly = false,
}) {
  const v = normalizeDriverDocumentValue(value);

  if (!verificationId || !personId || v.skipped) return;

  if (v.pdf && !photoOnly) {
    uploadPromises.push(
      uploadDriverDocument(verificationId, personId, docType, v.pdf, 'pdf')
        .catch((err) =>
          console.error(`Failed to upload ${docType} pdf:`, err)
        )
    );

    return;
  }

  if (v.front) {
    uploadPromises.push(
      uploadDriverDocument(verificationId, personId, docType, v.front, 'front')
        .catch((err) =>
          console.error(`Failed to upload ${docType} front:`, err)
        )
    );
  }

  if (!photoOnly && v.back) {
    uploadPromises.push(
      uploadDriverDocument(verificationId, personId, docType, v.back, 'back')
        .catch((err) =>
          console.error(`Failed to upload ${docType} back:`, err)
        )
    );
  }
}

const API_BASE_URL = "https://api.taxi-yaounde.com";
// const API_BASE_URL = "http://localhost:4000";

const DriverManager = ({
  vehicleId,
  verificationId,
  onDriversChange,
  initialDrivers = [],
}) => {
  const scrollViewRef = useRef(null);
  const { t } = useTranslation();
  const [drivers, setDrivers] = useState(() =>
    Array.isArray(initialDrivers) ? initialDrivers : []
  );
  const [loading, setLoading] = useState(false);
  const { verification, setVerification } = useContext(AppContext);
  const [isNoLongerDriver, setIsNoLongerDriver] = useState(false);
  
  // Document states for each driver
  const [driverDocuments, setDriverDocuments] = useState({});

  // Fetch existing drivers for this vehicle
  useEffect(() => {
    if (vehicleId) {
      fetchExistingDrivers();
    }
  }, [vehicleId]);

  // Update verification context whenever drivers change
  useEffect(() => {
    updateOwnerAddedDriverPersonIds();
  }, [drivers]);

  const updateOwnerAddedDriverPersonIds = () => {
    const ownerAddedDriverPersonIds = drivers
      .filter(d => !d.fetchedFromDB && d.personId)
      .map(d => d.personId);
    
    console.log("Newly added driver personIds: - DriverManager.js:558", ownerAddedDriverPersonIds);
    
    setVerification(prev => ({ 
      ...prev, 
      ownerAddedDriverPersonIds 
    }));
  };

  const fetchExistingDrivers = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/api/verification/vehicles/${vehicleId}/drivers`
      );
      const data = await response.json();
      
      if (data.success && data.drivers) {
        const existingDrivers = data.drivers.map(driver => ({
          ...driver,
          isExisting: true,
          fetchedFromDB: true,
          // Add document status fields
          licenseCategory: driver.licenseCategory || '',
          // Capacity fields
          hasCapacityDoc: true,
          capacityNumber: driver.capacityNumber || '',
          // Secure badge fields
          hasSecureBadgeDoc: true,
          secureBadge: null,
          driverPhotoFile: emptyDriverDocument(),
          driverLicenseFile: emptyDriverDocument(),
          driverIdCardFile: emptyDriverDocument(),
          driverCapacityFile: emptyDriverDocument(),
          driverResidenceCardFile: emptyDriverDocument(),
          driverProfessionalBadgeFile: emptyDriverDocument(),

          hasDriverPhoto: false,
          hasDriverLicense: false,
          hasDriverIdCard: false,
          hasDriverCapacity: false,
          hasDriverResidenceCard: false,
          hasDriverProfessionalBadge: false,
        }));
        setDrivers(existingDrivers);
        onDriversChange(existingDrivers);
        updateOwnerAddedDriverPersonIds();
      } else {
        setDrivers([]);
        onDriversChange([]);
        updateOwnerAddedDriverPersonIds();
      }
    } catch (error) {
      console.error('Error fetching drivers: - DriverManager.js:601', error);
      setDrivers([]);
      onDriversChange([]);
      updateOwnerAddedDriverPersonIds();
    } finally {
      setLoading(false);
    }
  };

  const addDriver = () => {
    const newDriver = {
      id: Date.now().toString(),
      name: '',
      phone: '',
      email: '',
      birthDate: '',
      gender: '',
      cinNumber: '',
      taxpayerNumber: '',
      licenseNumber: '',
      licenseCategory: '', // New field
      driverSyndicate: '', 
      isExisting: false,
      fetchedFromDB: false,
      // Capacity fields (moved from parent)
      hasCapacityDoc: true,
      capacityNumber: '',
      // Secure badge fields (moved from parent)
      hasSecureBadgeDoc: true,
      secureBadge: null,
      // Document status (for tracking)
      driverPhotoFile: emptyDriverDocument(),
      driverLicenseFile: emptyDriverDocument(),
      driverIdCardFile: emptyDriverDocument(),
      driverCapacityFile: emptyDriverDocument(),
      driverResidenceCardFile: emptyDriverDocument(),
      driverProfessionalBadgeFile: emptyDriverDocument(),

      hasDriverPhoto: false,
      hasDriverLicense: false,
      hasDriverIdCard: false,
      hasDriverCapacity: false,
      hasDriverResidenceCard: false,
      hasDriverProfessionalBadge: false,
    };
    
    const updatedDrivers = [newDriver, ...drivers];
    setDrivers(updatedDrivers);
    onDriversChange(updatedDrivers);
    
    // Auto-scroll to top
    setTimeout(() => {
      scrollViewRef.current?.scrollTo({ y: 0, animated: true });
    }, 100);
  };

  const removeDriver = (index) => {
    if (drivers[index].fetchedFromDB) {
      Alert.alert(
        t('driverManager.cannotRemove'),
        t('driverManager.cannotRemoveMessage')
      );
      return;
    }
    const newDrivers = [...drivers];
    newDrivers.splice(index, 1);
    setDrivers(newDrivers);
    onDriversChange(newDrivers);
  };

  const updateDriver = (index, field, value) => {
    const newDrivers = [...drivers];
    newDrivers[index][field] = value;
    
    if (newDrivers[index].fetchedFromDB && field !== 'searchTerm') {
      newDrivers[index].isModified = true;
    }
    
    setDrivers(newDrivers);
    onDriversChange(newDrivers);
  };

  const handleDriverDocumentValue = (index, docType, value, options = {}) => {
  const { photoOnly = false } = options;
  const normalized = normalizeDriverDocumentValue(value);

  const config = {
    DRIVER_PHOTO: {
      fileField: 'driverPhotoFile',
      hasField: 'hasDriverPhoto',
      photoOnly: true,
    },
    DRIVER_LICENSE: {
      fileField: 'driverLicenseFile',
      hasField: 'hasDriverLicense',
    },
    DRIVER_ID_CARD: {
      fileField: 'driverIdCardFile',
      hasField: 'hasDriverIdCard',
    },
    DRIVER_CAPACITY: {
      fileField: 'driverCapacityFile',
      hasField: 'hasDriverCapacity',
    },
    DRIVER_RESIDENCE_CARD: {
      fileField: 'driverResidenceCardFile',
      hasField: 'hasDriverResidenceCard',
    },
    DRIVER_PROFESSIONAL_BADGE: {
      fileField: 'driverProfessionalBadgeFile',
      hasField: 'hasDriverProfessionalBadge',
    },
  };

  const item = config[docType];
  if (!item) return;

  updateDriver(index, item.fileField, normalized);
  updateDriver(
    index,
    item.hasField,
    hasCompleteTwoSidedDocument(normalized, {
      photoOnly: item.photoOnly || photoOnly,
    })
  );

  setDriverDocuments((prev) => ({
    ...prev,
    [drivers[index].personId || drivers[index].id || index]: {
      ...(prev[drivers[index].personId || drivers[index].id || index] || {}),
      [docType]: normalized,
    },
  }));
  };

  const handleDriverDocumentSkip = (index, docType) => {
    handleDriverDocumentValue(index, docType, skippedDriverDocument());
  };

  const searchExistingDriver = async (cinOrLicense, index) => {
    if (!cinOrLicense.trim()) return;
    
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/verification/persons/search?cin=${cinOrLicense}&license=${cinOrLicense}`
      );
      const data = await response.json();
      
      if (data.success && data.person) {
        const newDrivers = [...drivers];
        newDrivers[index] = {
          ...newDrivers[index],
          ...data.person,
          isExisting: true,
          fetchedFromDB: true,
          personId: data.person.personId,
          // Preserve document status fields with defaults
          hasDriverPhoto: false,
          hasDriverLicense: false,
          hasDriverIdCard: false,
          hasDriverCapacity: false,
          licenseCategory: data.person.licenseCategory || '',
          hasCapacityDoc: true,
          capacityNumber: data.person.capacityNumber || '',
          hasSecureBadgeDoc: true,
          secureBadge: null,
        };
        setDrivers(newDrivers);
        onDriversChange(newDrivers);
        updateOwnerAddedDriverPersonIds();
        
        Alert.alert(
          t('driverManager.driverFound'),
          t('driverManager.driverFoundMessage')
        );
      }
    } catch (error) {
      console.error('Error searching driver: - DriverManager.js:741', error);
    }
  };

  const handleSaveDriverToBackend = async (index) => {
    const driver = drivers[index];
    
    if (driver.fetchedFromDB || !driver.name || !driver.phone) {
      return;
    }
    
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/verification/persons/create`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: driver.name,
            phone: driver.phone,
            email: driver.email || '',
            birthDate: driver.birthDate || '',
            gender: driver.gender || '',
            cinNumber: driver.cinNumber || '',
            taxpayerNumber: driver.taxpayerNumber || '',
            licenseNumber: driver.licenseNumber || '',
            licenseCategory: driver.licenseCategory || '',
            driverSyndicate: driver.driverSyndicate || '',
            capacityNumber: driver.capacityNumber || '',
          }),
        }
      );
      
      const data = await response.json();
      
      if (data.success && data.personId) {
        const newDrivers = [...drivers];
        newDrivers[index].personId = data.personId;
        setDrivers(newDrivers);
        onDriversChange(newDrivers);
        updateOwnerAddedDriverPersonIds();
        
        Alert.alert(
          t('driverManager.driverSaved'),
          t('driverManager.driverSavedMessage')
        );
      }
    } catch (error) {
      console.error('Error saving driver: - DriverManager.js:791', error);
      Alert.alert(
        t('common.error'),
        t('driverManager.saveError')
      );
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>{t('driverManager.title')}</Text>
        <TouchableOpacity style={styles.addButton} onPress={addDriver}>
          <Text style={styles.addButtonText}>{t('driverManager.addDriver')}</Text>
        </TouchableOpacity>
      </View>

      {loading ? (
        <Text style={styles.loadingText}>{t('driverManager.loadingDrivers')}</Text>
      ) : (
        <ScrollView style={styles.scrollView} ref={scrollViewRef}>
          {drivers.map((driver, index) => (
            <View key={driver.id || driver.personId || index} style={styles.driverCard}>
              <View style={styles.cardHeader}>
                <Text style={styles.driverTitle}>
                  {t('driverManager.driverTitle').replace("{{number}}", index + 1)}
                  {driver.fetchedFromDB && t('driverManager.existingInDatabase')}
                  {driver.isModified && t('driverManager.modified')}
                </Text>
                {!driver.fetchedFromDB && (
                  <TouchableOpacity onPress={() => removeDriver(index)}>
                    <Text style={styles.removeText}>{t('common.remove')}</Text>
                  </TouchableOpacity>
                )}
              </View>

              {/* Basic Info Section */}
              <Text style={styles.sectionSubtitle}>{t('driverManager.sections.basicInfo')}</Text>
              
              <Text style={styles.label}>{t('driverManager.fields.fullName')}</Text>
              <TextInput
                style={styles.input}
                value={driver.name}
                onChangeText={(text) => updateDriver(index, 'name', text)}
                placeholder={t('driverManager.fields.fullName')}
                editable={!driver.fetchedFromDB}
              />

              <Text style={styles.label}>{t('driverManager.fields.phone')}</Text>
              <TextInput
                style={styles.input}
                value={driver.phone}
                onChangeText={(text) => updateDriver(index, 'phone', text)}
                placeholder={t('driverManager.fields.phone')}
                keyboardType="phone-pad"
                editable={!driver.fetchedFromDB}
              />

              <Text style={styles.label}>{t('driverManager.fields.email')}</Text>
              <TextInput
                style={styles.input}
                value={driver.email}
                onChangeText={(text) => updateDriver(index, 'email', text)}
                placeholder={t('driverManager.fields.email')}
                keyboardType="email-address"
                autoCapitalize="none"
                editable={!driver.fetchedFromDB}
              />

              <Text style={styles.label}>{t('driverManager.fields.birthDate')}</Text>
              <TextInput
                style={styles.input}
                value={driver.birthDate}
                onChangeText={(text) => updateDriver(index, 'birthDate', text)}
                placeholder="DD/MM/YYYY"
                editable={!driver.fetchedFromDB}
              />

              <Text style={styles.label}>{t('driverManager.fields.gender')}</Text>
              <View style={styles.row}>
                {[t('driverManager.genders.male'), t('driverManager.genders.female')].map((gender) => (
                  <TouchableOpacity
                    key={gender}
                    style={[
                      styles.genderButton,
                      driver.gender === gender && styles.genderButtonActive,
                    ]}
                    onPress={() => updateDriver(index, 'gender', gender)}
                    disabled={driver.fetchedFromDB}
                  >
                    <Text
                      style={[
                        styles.genderText,
                        driver.gender === gender && styles.genderTextActive,
                      ]}
                    >
                      {gender}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>

              <Text style={styles.label}>{t('driverManager.fields.cinNumber')}</Text>
              <TextInput
                style={styles.input}
                value={driver.cinNumber}
                onChangeText={(text) => updateDriver(index, 'cinNumber', text)}
                placeholder={t('driverManager.fields.cinNumber')}
                editable={!driver.fetchedFromDB}
              />

              <Text style={styles.label}>{t('driverManager.fields.taxpayerNumber')}</Text>
              <TextInput
                style={styles.input}
                value={driver.taxpayerNumber}
                onChangeText={(text) => updateDriver(index, 'taxpayerNumber', text)}
                placeholder={t('driverManager.fields.taxpayerNumber')}
                editable={!driver.fetchedFromDB}
              />

              {/* License Section */}
              <Text style={[styles.sectionSubtitle, styles.sectionSpacer]}>
                {t('driverManager.sections.licenseInfo')}
              </Text>

              <Text style={styles.label}>{t('driverManager.fields.licenseNumber')}</Text>
              <TextInput
                style={styles.input}
                value={driver.licenseNumber}
                onChangeText={(text) => updateDriver(index, 'licenseNumber', text)}
                placeholder={t('driverManager.fields.licenseNumber')}
                editable={!driver.fetchedFromDB}
              />

              {/* License Category Dropdown */}
              <LicenseCategoryDropdown
                value={driver.licenseCategory}
                onSelect={(category) => updateDriver(index, 'licenseCategory', category)}
                editable={!driver.fetchedFromDB}
              />

              {/* Capacity Section (moved from parent) */}
              <Text style={[styles.sectionSubtitle, styles.sectionSpacer]}>
                {t('driverManager.sections.capacityInfo')}
              </Text>

              {/* Capacity Document Checkbox */}
              <TouchableOpacity
                style={styles.checkRow}
                onPress={() => {
                  const newValue = !driver.hasCapacityDoc;
                  updateDriver(index, 'hasCapacityDoc', newValue);
                  if (!newValue) {
                    updateDriver(index, 'capacityNumber', '');
                  }
                }}
                disabled={driver.fetchedFromDB}
              >
                <View style={[styles.checkBox, !driver.hasCapacityDoc && styles.checkBoxOn]}>
                  {!driver.hasCapacityDoc && <Text style={styles.checkMark}>✓</Text>}
                </View>
                <Text style={styles.checkLabel}>
                  {t('driverManager.dontHaveCapacity')}
                </Text>
              </TouchableOpacity>

              {driver.hasCapacityDoc && (
                <>
                  <Text style={styles.label}>{t('driverManager.fields.capacityNumber')}</Text>
                  <TextInput
                    style={styles.input}
                    value={driver.capacityNumber}
                    onChangeText={(text) => updateDriver(index, 'capacityNumber', text)}
                    placeholder={t('driverManager.fields.capacityNumberPlaceholder')}
                    editable={!driver.fetchedFromDB}
                  />
                </>
              )}

              {/* Secure Badge Section (moved from parent) */}
              <Text style={[styles.sectionSubtitle, styles.sectionSpacer]}>
                {t('driverManager.sections.secureBadge')}
              </Text>

              {/* Secure Badge Checkbox */}
              <TouchableOpacity
                style={styles.checkRow}
                onPress={() => {
                  const newValue = !driver.hasSecureBadgeDoc;
                  updateDriver(index, 'hasSecureBadgeDoc', newValue);
                  if (!newValue) {
                    updateDriver(index, 'secureBadge', null);
                  }
                }}
                disabled={driver.fetchedFromDB}
              >
                <View style={[styles.checkBox, !driver.hasSecureBadgeDoc && styles.checkBoxOn]}>
                  {!driver.hasSecureBadgeDoc && <Text style={styles.checkMark}>✓</Text>}
                </View>
                <Text style={styles.checkLabel}>
                  {t('driverManager.dontHaveSecureBadge')}
                </Text>
              </TouchableOpacity>

              {driver.hasSecureBadgeDoc && (
                <>
                  <Text style={styles.label}>{t('driverManager.fields.secureBadge')}</Text>
                  <View style={styles.row}>
                    <TouchableOpacity
                      style={[
                        styles.pillButton,
                        driver.secureBadge === true && styles.pillButtonActive,
                      ]}
                      onPress={() => updateDriver(index, 'secureBadge', true)}
                      disabled={driver.fetchedFromDB}
                    >
                      <Text style={[
                        styles.pillText,
                        driver.secureBadge === true && styles.pillTextActive,
                      ]}>
                        {t('common.yes')}
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[
                        styles.pillButton,
                        driver.secureBadge === false && styles.pillButtonActive,
                      ]}
                      onPress={() => updateDriver(index, 'secureBadge', false)}
                      disabled={driver.fetchedFromDB}
                    >
                      <Text style={[
                        styles.pillText,
                        driver.secureBadge === false && styles.pillTextActive,
                      ]}>
                        {t('common.no')}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </>
              )}

              <Text style={styles.label}>{t("driverManager.fields.driverSyndicate")}</Text>
              <TextInput
                style={styles.input}
                value={driver.driverSyndicate}
                onChangeText={(text) => updateDriver(index, 'driverSyndicate', text)}
                placeholder={t("driverManager.fields.driverSyndicate")}
                editable={!driver.fetchedFromDB}
              />

              {/* Documents Section */}
              <Text style={[styles.sectionSubtitle, styles.sectionSpacer]}>
                {t('driverManager.sections.documents')}
              </Text>


              {/* Driver Photo Upload */}
              <DriverDocumentUpload
                docType="DRIVER_PHOTO"
                label={t('driverManager.documents.photo')}
                value={driver.driverPhotoFile}
                onFileSelected={(value) =>
                  handleDriverDocumentValue(index, 'DRIVER_PHOTO', value, { photoOnly: true })
                }
                onSkip={() => handleDriverDocumentSkip(index, 'DRIVER_PHOTO')}
                disabled={driver.fetchedFromDB}
              />

              <DriverDocumentUpload
                docType="DRIVER_LICENSE"
                label={t('driverManager.documents.license')}
                value={driver.driverLicenseFile}
                onFileSelected={(value) =>
                  handleDriverDocumentValue(index, 'DRIVER_LICENSE', value)
                }
                onSkip={() => handleDriverDocumentSkip(index, 'DRIVER_LICENSE')}
                disabled={driver.fetchedFromDB}
              />

              <DriverDocumentUpload
                docType="DRIVER_ID_CARD"
                label={t('driverManager.documents.idCard')}
                value={driver.driverIdCardFile}
                onFileSelected={(value) =>
                  handleDriverDocumentValue(index, 'DRIVER_ID_CARD', value)
                }
                onSkip={() => handleDriverDocumentSkip(index, 'DRIVER_ID_CARD')}
                disabled={driver.fetchedFromDB}
              />

              <DriverDocumentUpload
                docType="DRIVER_CAPACITY"
                label={t('driverManager.documents.capacity')}
                value={driver.driverCapacityFile}
                onFileSelected={(value) =>
                  handleDriverDocumentValue(index, 'DRIVER_CAPACITY', value)
                }
                onSkip={() => handleDriverDocumentSkip(index, 'DRIVER_CAPACITY')}
                disabled={driver.fetchedFromDB}
              />

              <DriverDocumentUpload
                docType="DRIVER_RESIDENCE_CARD"
                label="Carte de résidence"
                value={driver.driverResidenceCardFile}
                onFileSelected={(value) =>
                  handleDriverDocumentValue(index, 'DRIVER_RESIDENCE_CARD', value)
                }
                onSkip={() => handleDriverDocumentSkip(index, 'DRIVER_RESIDENCE_CARD')}
                disabled={driver.fetchedFromDB}
              />

              <DriverDocumentUpload
                docType="DRIVER_PROFESSIONAL_BADGE"
                label="Badge professionnel d'identification"
                value={driver.driverProfessionalBadgeFile}
                onFileSelected={(value) =>
                  handleDriverDocumentValue(index, 'DRIVER_PROFESSIONAL_BADGE', value)
                }
                onSkip={() => handleDriverDocumentSkip(index, 'DRIVER_PROFESSIONAL_BADGE')}
                disabled={driver.fetchedFromDB}
              />
              {/* Save Button for new drivers */}
              {/* {!driver.fetchedFromDB && driver.name && driver.phone && !driver.personId && (
                <TouchableOpacity
                  style={styles.saveButton}
                  onPress={() => handleSaveDriverToBackend(index)}
                >
                  <Text style={styles.saveButtonText}>
                    {t('common.saveDriver')}
                  </Text>
                </TouchableOpacity>
              )} */}
                <TouchableOpacity
                  style={styles.checkRow}
                  onPress={() => setIsNoLongerDriver(!isNoLongerDriver)}
                  // disabled={saving}
                >
                  <View style={[styles.checkBox, isNoLongerDriver && styles.checkBoxOn]}>
                    {isNoLongerDriver && <Text style={styles.checkMark}>✓</Text>}
                  </View>
                  <Text style={[
                    styles.checkLabel,
                    isNoLongerDriver && styles.checkLabelActive
                  ]}>
                    {t('driverManager.noLongerDriver')}
                  </Text>
                </TouchableOpacity>
            </View>
          ))}
        </ScrollView>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: COLORS.card,
    borderRadius: 16,
    padding: 16,
    marginVertical: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: COLORS.textDark,
  },
  addButton: {
    backgroundColor: COLORS.primary,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  addButtonText: {
    color: '#FFFFFF',
    fontWeight: '600',
  },
  scrollView: {
    maxHeight: 500,
  },
  driverCard: {
    backgroundColor: COLORS.background,
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: COLORS.border,
    borderLeftWidth: 4,
    borderLeftColor: COLORS.primary,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  driverTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: COLORS.textDark,
  },
  removeText: {
    color: COLORS.error,
    fontWeight: '600',
  },
  sectionSubtitle: {
    fontSize: 15,
    fontWeight: '600',
    color: COLORS.primary,
    marginBottom: 10,
    marginTop: 5,
  },
  sectionSpacer: {
    marginTop: 15,
    borderTopWidth: 1,
    borderTopColor: COLORS.border,
    paddingTop: 10,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: COLORS.textMuted,
    marginTop: 8,
    marginBottom: 4,
  },
  input: {
    borderWidth: 1,
    borderColor: COLORS.border,
    borderRadius: 8,
    padding: 10,
    fontSize: 14,
    marginBottom: 8,
    backgroundColor: COLORS.card,
  },
  row: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 8,
  },
  genderButton: {
    flex: 1,
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border,
    alignItems: 'center',
  },
  genderButtonActive: {
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
  },
  genderText: {
    color: COLORS.textDark,
    fontWeight: '600',
  },
  genderTextActive: {
    color: '#FFFFFF',
  },
  pillButton: {
    flex: 1,
    paddingVertical: 10,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: COLORS.border,
    alignItems: 'center',
  },
  pillButtonActive: {
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
  },
  pillText: {
    color: COLORS.textDark,
    fontWeight: '600',
  },
  pillTextActive: {
    color: '#FFFFFF',
  },
  checkRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginVertical: 8,
  },
  checkBox: {
    width: 22,
    height: 22,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: COLORS.border,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkBoxOn: {
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
  },
  checkMark: {
    color: '#fff',
    fontWeight: '900',
  },
  checkLabel: {
    color: COLORS.textDark,
    fontWeight: '600',
    flex: 1,
  },
  saveButton: {
    backgroundColor: COLORS.primary,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    marginTop: 16,
  },
  saveButtonText: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: 14,
  },
  loadingText: {
    textAlign: 'center',
    color: COLORS.textMuted,
    padding: 20,
  },
  checkLabelActive: {
    color: COLORS.primary,
    fontWeight: '600',
  },
});

export default DriverManager;